import React from 'react';
import PropTypes from 'prop-types';

import Svg from '@dbk/ui-svg';

import PorfolioChartLegendItem from './legend-item';

export const renderItems = renderItem => items => {
  return items.map(renderItem);
};

export const renderItem = (color) => {
  return (
    <Svg width={20} height={20}>
      <PorfolioChartLegendItem fill={color} stroke={color}/>
    </Svg>
  )
};

export const defaultProps = {
  items: []
};

export const propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired
};